// extracted by mini-css-extract-plugin
export default {"webViewerContainer":"PaperViewer_webViewerContainer__qIOGX","webViewer":"PaperViewer_webViewer__96OIy","processingContainer":"PaperViewer_processingContainer__Kjc7v"};